import cls from "@fvilers/cls";
import { ComponentPropsWithRef, ElementType } from "react";
import styles from "./Skeleton.module.css";

export function ButtonSkeleton({
  className,
  size = "md",
  ...props
}: { size?: "md" | "sm" } & React.HTMLAttributes<
  Omit<HTMLDivElement, "size">
>) {
  return (
    <Skeleton
      className={cls(
        styles.ButtonSkeleton,
        size === "sm" && styles.sizeSm,
        className,
      )}
      {...props}
    />
  );
}

export function CheckboxSkeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={cls(styles.CheckboxSkeletonWrapper, className)}>
      <Skeleton className={styles.CheckboxSkeleton} {...props} />
    </div>
  );
}

export function ImageSkeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Skeleton className={cls(styles.ImageSkeleton, className)} {...props} />
  );
}

export function Skeleton<T extends ElementType = "div">({
  as,
  className,
  ...props
}: {
  as?: T;
} & ComponentPropsWithRef<T>) {
  const Component = as || "div";
  return <Component className={cls(styles.Skeleton, className)} {...props} />;
}

export function SwitchSkeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <Skeleton className={cls(styles.SwitchSkeleton, className)} {...props} />
  );
}

export function TextSkeleton<T extends ElementType = "span">({
  as = "span",
  className,
  ...props
}: {
  as?: T;
} & ComponentPropsWithRef<T>) {
  return (
    <Skeleton
      as={as}
      className={cls(styles.TextSkeleton, className)}
      {...props}
    />
  );
}
